import styled from 'styled-components';

export const StyledNewsDiv = styled.div`
  white-space: pre-wrap;
  color: white;
  min-height: 40vh;
  padding: 0 40px;
  margin-bottom: 21px;
`;

export const StyledNewsTitle = styled.h1`
  padding-bottom: 0;
  margin-bottom: 0;
  padding-top: 40px;
  margin-top: 0px;
`;

export const StyledNewsTimestamp = styled.span`
  display: block;
  font-size: 10px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 2px solid white;
`;

export const StyledNewsContent = styled.span`
  margin-top: 20px;
  a {
    text-decoration: underline;
  }
`;
